import React from 'react'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'

const LoadingRequest = () => {
  return (
    <Box height={350} display="flex" justifyContent="center" alignItems="center" marginTop={2}>
      <CircularProgress sx={{ color: 'alternate' }} />
    </Box>
  )
}

export default LoadingRequest
